import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardRoute from 'pages/routes/routes';
import LoginCallback from 'components/entra/LoginCallback';
import useScrollToTopOnRouteChange from 'utility/hooks/useScrollToTopOnRouteChange';
import AnalyticsProvider from 'providers/AnalyticProvider';
import GlobalFilterProvider from 'providers/GlobalFilterProvider';
import BreadcrumbProvider from 'providers/BreadcrumbProvider';
import NavigationBar from '../../section/01_NavigationBarSection/NavigationBar.section';
import RequireAuth from '../../components/entra/RequireAuth';
import './_dashboard.scss';

function Dashboards() {
  useScrollToTopOnRouteChange();
  /*
  Commenting for future reference
  const navigate = useNavigate();
  
  const restoreOriginalUri = async (_, originalUri) => { // check dev to test
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };
  */

  return (
    <AnalyticsProvider>
      <GlobalFilterProvider>
        <BreadcrumbProvider>
          <div>
            <Routes>
              <Route path="/login/callback" element={<LoginCallback />} />
            </Routes>
            <RequireAuth>
              <div className="row compass-nav-holder">
                <NavigationBar />
              </div>
              <div className="row compass-content" data-testid="content-root">
                <div className="col-12">
                  <DashboardRoute />
                </div>
              </div>
            </RequireAuth>
          </div>
        </BreadcrumbProvider>
      </GlobalFilterProvider>
    </AnalyticsProvider>
  );
}

export default Dashboards;
